import React, { useRef, useCallback } from 'react';
import { useExpanded, useTable } from 'react-table';
import cn from 'classnames';

const Table = ({ columns: userColumns, data, renderRowSubComponent, onScroll, onClick }) => {
  const observer = useRef();

  const lastRentElementRef = useCallback(
    (node) => {
      if (observer.current) {
        observer.current.disconnect();
      }
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          onScroll();
        }
      });
      if (node) {
        observer.current.observe(node);
      }
    },
    [data]
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, visibleColumns } = useTable(
    {
      columns: userColumns,
      data,
    },
    useExpanded
  );

  return (
    <table className="table-content" {...getTableProps()}>
      <thead>
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => {
              return (
                <th className="table-header" {...column.getHeaderProps()}>
                  {column.render('Header')}
                </th>
              );
            })}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row, index) => {
          prepareRow(row);
          const rowProps = row.getRowProps();
          const tableRef = data.length === index + 1 ? lastRentElementRef : null;
          return (
            <React.Fragment key={rowProps.key}>
              <tr
                {...rowProps}
                ref={tableRef}
                className={cn(
                  'tr-table-main',
                  row.isExpanded && 'brightness',
                  row.original.class === 'last-reservation' && 'reserve-tr'
                )}
              >
                {row.cells.map((cell, cellIndex) => {
                  const click = cellIndex === 0 ? () => {} : onClick;
                  return (
                    <th className="cell" onClick={() => click(cell.row.original)} {...cell.getCellProps()}>
                      {cell.render('Cell')}
                    </th>
                  );
                })}
              </tr>
              {row.isExpanded && renderRowSubComponent({ row, rowProps, visibleColumns })}
            </React.Fragment>
          );
        })}
      </tbody>
    </table>
  );
};

export { Table };
